import { render } from "./Section01.vue?vue&type=template&id=4ba025cb&scoped=true"
import script from "./Section01.vue?vue&type=script&lang=js"
export * from "./Section01.vue?vue&type=script&lang=js"

import "./Section01.vue?vue&type=style&index=0&id=4ba025cb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba025cb"]])

export default __exports__